import { Component } from '@angular/core';

@Component({
  template: '<a-load-error></a-load-error>'
})
export class LoadErrorPageComponent {}
